module.exports = __webpack_public_path__ + "img/节日派对-2@2x.71b01abe.png";